import Tabs from './tabs/tabs';
import Tab from './tab/tab';
import RangeInput from './rangeInput/rangeInput';
import CheckboxInput from './checkboxInput/checkboxInput';
import RadioButtonInput from './radioButtonInput/radioButtonInput';
import JobItem from './jobItem/jobItem';
import DetailedJobItem from './detailedJobItem/detailedJobItem';
import MyInterests from './myInterests/myInterests';
import MySkills from './mySkills/mySkills';
import MyEducation from './myEducation/myEducation';
import MyMatchingJobs from './myMatchingJobs/myMatchingJobs';
import JobNavbar from './jobNavbar/jobNavbar';
import SidePanelInterests from './sidePanelInterests/sidePanelInterests';
import SidePanelSkills from './sidePanelSkills/sidePanelSkills';
import SidePanelEducation from './sidePanelEducation/sidePanelEducation';
import CareerOpps from './careerOpps/careerOpps';
import CareerCircle from './careerCircle/careerCircle';
import Autosave from './autosave/autosave';
import OverallMatch from './overallMatch/overallMatch';
import InterestMatch from './interestMatch/interestMatch';
import SkillCount from './skillCount/skillCount';
import BestJobs from './bestJobs/bestJobs';
import AllMatchingJobs from './allMatchingJobs/allMatchingJobs';
import NearbyLocations from './nearbyLocations/nearbyLocations';
import MatchMe from './matchMe/matchMe';
import PersonalizePrompt from './personalizePrompt/personalizePrompt';
import './components.styl';

let ComponentsModule = angular.module('app.components', [
  Tabs.name,
  Tab.name,
  RangeInput.name,
  CheckboxInput.name,
  RadioButtonInput.name,
  JobItem.name,
  DetailedJobItem.name,
  MyInterests.name,
  MySkills.name,
  MyEducation.name,
  MyMatchingJobs.name,
  JobNavbar.name,
  SidePanelInterests.name,
  SidePanelSkills.name,
  SidePanelEducation.name,
  CareerOpps.name,
  CareerCircle.name,
  Autosave.name,
  OverallMatch.name,
  InterestMatch.name,
  SkillCount.name,
  BestJobs.name,
  AllMatchingJobs.name,
  NearbyLocations.name,
  MatchMe.name,
  PersonalizePrompt.name
]);

export default ComponentsModule;



// WEBPACK FOOTER //
// ./src/components/components.js